<script>
  import options from './SchemaMarkupNumber.options'
  export default options
</script>

<template>
  <div class="kb-field" :class="{ 'kb-field--readonly': readonly }">
    <label v-if="label" :for="fieldId" class="kb-field__label">{{ label }}</label>

    <input
      :id="fieldId"
      class="kb-field__input"
      type="number"
      :value="modelValue"
      :readonly="readonly"
      @input="onInput"
    />
  </div>
</template>
